import * as React from 'react';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { PricingPageDto } from "../../models";

interface PricingPagePickerModalProps {
    pricingPages: PricingPageDto[];
    onPricingPageSelected: (id: number) => void;
    isOpen: boolean;
    toggle: () => void;
}

interface PricingPagePickerModalState {
}

export class PricingPagePickerModal extends React.PureComponent<PricingPagePickerModalProps, PricingPagePickerModalState> {
    constructor(props: PricingPagePickerModalProps) {
        super(props);

        this.state = {
        }
    }

    public render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="modal-dialog-centered modal-lg">
                    <ModalHeader toggle={this.props.toggle}>Hivatkozás kiválasztása</ModalHeader>
                    <ModalBody>
                        <div className="list-group">
                            {this.props.pricingPages.map((pricingPage, index) => {
                                return (
                                    <div key={index} className="list-group-item list-group-item-action" style={{ cursor: "pointer" }} onClick={() => this.props.onPricingPageSelected(pricingPage.id)}>
                                        {pricingPage.name}
                                    </div>
                                );
                            })}
                        </div>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        );
    }
}

export default PricingPagePickerModal;
